/*
 app dependencies
 - var body

 lib dependencies
*/

const scGoldDigger = (function()
{
	let _shown = false;

	//module functions
	function init()
	{
		const trigger = document.querySelector('.js-golddigger-trigger');
		if (trigger)
		{
			lmnInView.register({ el: trigger, in: _show })
		}
	}

	function _show()
	{
		if (_shown) return;

		window.body.classList.add('show-golddigger')

		_shown = true;

		const hideBtn = document.querySelector('.js-hide-golddigger');
		if (hideBtn)
		{
			hideBtn.addEventListener('click', function(e)
			{
				e.preventDefault();
				window.body.classList.remove('show-golddigger');
			});
		}
	}


	//reveal public vars and functions
	return {
		//vars

		//functions
		init
	};

})();
